import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RequesterService } from '../../services/requester.service';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-outliers-info-capture',
  templateUrl: './outliers-info-capture.component.html',
  styleUrls: ['./outliers-info-capture.component.scss'],
  standalone: false
})
export class OutliersInfoCaptureComponent implements OnInit {
  @Input() selectedPoints: any;
  @Input() selectedParam: any;
  @Output() afterSubmit: EventEmitter<boolean> = new EventEmitter();

  comment: any = '';
  userDtls: any = {};

  constructor(
    private toastr: ToastrService,
    private requester: RequesterService,
    public dialog: MatDialog,
    private authService: MsalService
  ) { }

  ngOnInit() {
    // this.userDtls = this.adalService.userInfo;
    const account = this.authService?.instance?.getActiveAccount?.();
    this.userDtls = account ? account : {};
  }

  setOutliers() {
    this.requester.setPointsAsOutliers(this.selectedPoints, this.selectedParam, this.comment, this.userDtls)
      .subscribe(
        res => {
          if (res && res.status === 'Success') {
            this.toastr.success('Marked as outliers', 'Success');
            this.afterSubmit.emit(true);
            const ref = this.dialog.openDialogs.pop();
            if (ref) {
              ref.close({ submitted: true });
            }
            this.selectedPoints = [];
            this.comment = '';
          }
        }
      );
  }

  closeFunction() {
    const ref = this.dialog.openDialogs.pop();
    if (ref) {
      ref.close();
    }
  }
}
